// Putting everything into the window.polygon variable, so that we don't have heaps of messy globals.
window.polygon = window.polygon || {};

window.polygonSchoolEnquiryForm = (function($) {

    var settings = {
    };

    function init() {

        $('#table-wrap')
            .on('change click', '.f-quantity_term select, .f-quantity_year select', updateTotals)
            .on('change',       '.f-quantity_term select, .f-quantity_year select', autoSaveCart)
            .on('click',        '.inline-delete-button', function(ev){
                ev.preventDefault();
                if (window.confirm("Really delete this item from your cart?")) {
                    $("#" + $(this).data('target')).val('yes');
                    $(this).parents('tr').slideUp('fast', function() {
                        updateTotals();
                    });
                    autoSaveCart();
                }
            });

        updateTotals();

    }

    function updateTermTotal() {
        var qty = 0;
        var gold = 0;
        $('.f-quantity_term').each(function() {
            if ($(this).closest('tr').is(':visible')) {
                var $this = $(this);
                var q = parseInt($this.find('select').val());
                qty = qty + q;
                gold = gold + (q * parseFloat($this.data('rate')));
            }
        });
        $('#total_amount_term').text($.fn.currency('format', gold));
        $('#total_qty_term').text(qty);
    }

    function updateYearTotal() {
        var qty = 0;
        var gold = 0;
        $('.f-quantity_year').each(function() {
            if ($(this).closest('tr').is(':visible')) {
                var $this = $(this);
                var q = parseInt($this.find('select').val());
                qty = qty + q;
                gold = gold + (q * parseFloat($this.data('rate')));
            }
        });
        $('#total_amount_year').text($.fn.currency('format', gold));
        $('#total_qty_year').text(qty);
    }

    function updateTotals() {
        updateTermTotal();
        updateYearTotal();
    }

    function autoSaveCart() {

        var $form = $('#school-enquiry-form');
        $form.find('.ajax-errors').html('');
        var url = $form.data('auto-save-url');
        if (url) {
            var data = $form.serialize();
            $form.fadeTo(200, 0.5);
            $.post($form.data('auto-save-url'), data, function (r) {
                if (window.schoolsCartIcon !== undefined) {
                    window.schoolsCartIcon.updateCartButton();
                }
                $form.fadeTo(10, 1);
                $('#table-wrap').html(r.html);
                updateTotals();
            });
        }
    }

    return {
        init(options) {
            if (options) {
                $.extend( settings, options );
            }
            //Object.assign(settings, options || {});   // es5 equiv: if ( options ) { $.extend( settings, options ); }
            init();

        }
    };
})(jQuery);